import { ActionIcon, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";

/**
 * The header's scheme switch.
 *
 * ⚠ `variant="subtle"` with `color="gray"`, matching `NotificationBell` — these two sit
 * next to each other in `AuthedLayout`'s header and are the same KIND of thing (an icon
 * affordance on the chrome, not a control with a value). `variant="default"` draws
 * Mantine's bordered, filled button, which made the moon the only boxed item in a row of
 * bare icons and read as a different class of control.
 */
export function ColorSchemeToggle() {
    const { setColorScheme } = useMantineColorScheme();
    const computed = useComputedColorScheme("light");
    const next = computed === "light" ? "dark" : "light";
    return (
        <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            aria-label="Toggle color scheme"
            onClick={() => setColorScheme(next)}
        >
            {computed === "light" ? <IconMoon size={18} /> : <IconSun size={18} />}
        </ActionIcon>
    );
}
